import { render, staticRenderFns } from "./MedicationDosesTable.vue?vue&type=template&id=3fb3831c&"
import script from "./MedicationDosesTable.vue?vue&type=script&lang=js&"
export * from "./MedicationDosesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports